import './ad-swiper.scss';
import React from 'react';
import HttpsProtocolImage from '../common/https-protocol-image.jsx';

const TRANSITION = 0.6;
class AdSwiper extends React.Component {
  static defaultProps = {
    imgList: [],
    autoplay: 3500,
  }
  clientWith = document.body.clientWidth;
  bannerWidth = this.clientWith - 21;
  startX = 0;
  endX = 0;
  touchIndex = 1;
  timer = null;

  state = {
    translateX: -this.bannerWidth,
    transition: TRANSITION,
    isShowMask: true,
  };

  componentDidMount() {
    this.setAutoPlay();
  }

  componentWillUnmount() {
    this.clearAutoPlay();
  }

  setAutoPlay = () => {
    const { autoplay } = this.props;
    if (autoplay) {
      this.timer = setInterval(this.nextView, autoplay);
    }
  }

  clearAutoPlay = () => {
    clearInterval(this.timer);
    this.timer = null;
  }

  // 根据UI图在图片初始化的时候第一张右边没有最后一张的图片
  setMaskHidden = () => {
    const { isShowMask } = this.state;
    if (isShowMask) {
      this.setState({
        isShowMask: false,
      });
    }
  }

  touchStart = (e) => {
    this.clearAutoPlay();
    this.startX = e.changedTouches[0].clientX;
  }

  touchMove = (e) => {
    const touchVal = e.touches[0].clientX;
    const move = touchVal - this.startX;
    this.setState({
      transition: 0,
      translateX: -this.touchIndex * this.bannerWidth + move,
    });
  }

  touchEnd = (e) => {
    this.endX = e.changedTouches[0].clientX;
    if (this.startX - this.endX > 5) {
      this.nextView();
    }
    if (this.endX - this.startX > 5) {
      this.preView();
    }
  }

  nextView = () => {
    const len = this.props.imgList.length + 2;
    if (this.touchIndex >= len - 1) return;
    this.clearAutoPlay();
    const returnFirst = this.touchIndex === len - 2;
    // console.log('---returnFirst---', returnFirst);
    this.touchIndex++;
    const left = -this.touchIndex * this.bannerWidth;
    this.setState({
      transition: TRANSITION,
      translateX: left,
    });
    if (returnFirst) {
      setTimeout(() => {
        this.touchIndex = 1;
        this.setState({
          transition: 0,
          translateX: -this.bannerWidth,
        });
        this.setAutoPlay();
      }, 620);
    } else {
      this.setAutoPlay();
    }
    this.setMaskHidden();
  }

  preView = () => {
    if (this.touchIndex < 0) return;
    this.clearAutoPlay();
    const len = this.props.imgList.length + 2;
    const returnLast = this.touchIndex === 1;
    // console.log('---returnLast---', returnLast);
    this.touchIndex--;
    const left = -this.touchIndex * this.bannerWidth;
    this.setState({
      transition: TRANSITION,
      translateX: left,
    });
    if (returnLast) {
      setTimeout(() => {
        this.touchIndex = len - 2;
        this.setState({
          transition: 0,
          translateX: -this.touchIndex * this.bannerWidth,
        });
        this.setAutoPlay();
      }, 620);
    } else {
      this.setAutoPlay();
    }
    this.setMaskHidden();
  }

  render() {
    const { imgList } = this.props;
    const { transition, translateX, isShowMask } = this.state;
    const style = {
      width: `${this.clientWith - 28}px`,
      height: '29vw', // UI图 682 * 212
      borderRadius: '6px',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    };
    if (imgList.length === 0) return null;
    if (imgList.length === 1) {
      const imgItem = imgList[0];
      return (
        <div className="ad-swiper-container">
          <div className="ad-swiper-item">
            <a href={imgItem.url}>
              <HttpsProtocolImage
                src={imgItem.imgUrl}
                bgImg
                alt=""
                style={{
                  ...style,
                  backgroundImage: `url(${imgItem.imgUrl})`,
                }}
              />
            </a>
          </div>
        </div>
      );
    }
    const length = imgList.length;
    const swiperList = [imgList[length - 1], ...imgList, imgList[0]];
    return (
      <div
        className="ad-swiper-container"
        onTouchStart={this.touchStart}
        onTouchMove={this.touchMove}
        onTouchEnd={this.touchEnd}
      >
        {
          isShowMask ? <div className="ad-swiper-mask"></div> : null
        }
        <div
          className="ad-swiper"
          style={{
            width: `${this.bannerWidth * swiperList.length}px`,
            transition: `all ${transition}s ease`,
            transform: `translate3d(${translateX}px, 0, 0)`,
          }}
        >
          {
            swiperList.map((item, index) => (
              <div className="ad-swiper-item" key={index}>
                <a href={item.url}>
                  <HttpsProtocolImage
                    src={item.imgUrl}
                    bgImg
                    alt=""
                    style={{
                      ...style,
                      backgroundImage: `url(${item.imgUrl})`,
                    }}
                  />
                </a>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

AdSwiper.propTypes = {
  imgList: React.PropTypes.array,
  autoplay: React.PropTypes.number,
};

export default AdSwiper;



// WEBPACK FOOTER //
// ./src/component/shop-home/ad-swiper.jsx